import React from 'react';
import {
  datetime,
  type DatetimeType,
  type Moment,
} from '@common/services/datetime';
import { useCurrentMembership } from '@identity/hooks';

const TIME_VARIANT_MAP = {
  short_format: 'MM/DD/YYYY',
  long_format: 'MM/DD/YYYY [at] h:mma z',
  mid_format: 'MM/DD/YYYY, h:mmA',
  mid_format_with_tz: 'MM/DD/YYYY, h:mmA z',
  verbose_shorter: 'ddd, MMM D, YYYY',
  verbose_format: 'ddd, MMMM Do, YYYY',
};

// NOTE: Moment stays in the union because antd v4 picker and GraphQL call sites
// hold one; createDatetime takes it at runtime, datetime()'s signature does not.
type DateProp = string | DatetimeType | Moment | Date;

const toDatetime = (date: DateProp): DatetimeType =>
  datetime(date as Exclude<DateProp, Moment>);

export const ZonedTime = ({
  date,
  variant = 'short_format',
  timeZone = 'UTC',
}: {
  date: DateProp;
  variant?: keyof typeof TIME_VARIANT_MAP;
  timeZone?: string;
}) => {
  const format = TIME_VARIANT_MAP[variant];
  const currentMembership = useCurrentMembership({ hideError: true });

  if (!date) {
    return null;
  }

  const membershipTimeZone = currentMembership?.worksUser?.timeZone;
  const finalTimeZone = membershipTimeZone || timeZone;
  const finalDate = toDatetime(date).tz(finalTimeZone).format(format);

  return <>{finalDate}</>;
};
